import { cn } from '../lib/cn.js'

export type BadgeProps = {
  children: React.ReactNode
  tom?: 'marca' | 'destaque' | 'neutro' | 'sucesso' | 'alerta' | 'erro' | undefined
  className?: string | undefined
}

/** Etiqueta curta em Archivo Black, caixa alta — "faixas e etiquetas" do guia. */
export function Badge({ children, tom = 'neutro', className }: BadgeProps) {
  return <span className={cn('du-etiqueta', `du-etiqueta--${tom}`, className)}>{children}</span>
}
